/* POVA — product registry
 * Single source of truth for product metadata used across home + product pages.
 * Halo color = the "signal halo" the field tints toward on hover.
 * Order matches the launch sequence (newest first):
 *   POVA 8 → Curve 02 → Slim → 7 / 7 Pro → Curve (1) → 6 → 5
 */

window.POVA_PRODUCTS = [
  {
    id: "pova-8-green",
    index: "08",
    series: "Numbered",
    name: "POVA 8",
    variant: "Terminal Green",
    /* Verified POVA 8 campaign tagline */
    tagline: "Delete Normal.",
    price: "₹19,999",
    currency: "INR",
    status: "NEW",
    flag: "N",
    halo: "#5A7A52",                /* terminal green */
    spec: ["6.78\" AMOLED 144HZ", "6000 MAH", "12 + 256 GB", "5G"],
    href: "/pages/pova-8-experience?variant=green",
    image: "assets/img/pova-8-green.png"
  },
  {
    id: "pova-8-white",
    index: "08",
    series: "Numbered",
    name: "POVA 8",
    variant: "16-Bit White",
    tagline: "Delete Normal.",
    price: "₹19,999",
    currency: "INR",
    status: "NEW",
    flag: "N",
    halo: "#E8EAE8",                /* 16-bit white */
    spec: ["6.78\" AMOLED 144HZ", "6000 MAH", "12 + 256 GB", "5G"],
    href: "/pages/pova-8-experience?variant=white",
    image: "assets/img/pova-8-white.png"
  },
  {
    id: "pova-curve-2",
    index: "02",
    series: "Curve",
    name: "POVA Curve 02",
    variant: "Storm Titanium",
    /* Verified Curve 2 campaign tagline per 02_Verbal_Identity.md §6 */
    tagline: "Out of This World",
    price: "₹27,999",
    currency: "INR",
    status: "READY",
    flag: "R",
    halo: "#7A7E84",                /* storm titanium */
    spec: ["6.78\" CURVED AMOLED 144HZ", "8000 MAH", "8 + 256 GB", "IP64"],
    href: "/pages/pova-curve-2-experience",
    image: "assets/img/pova-curve-2-titanium.png"
  },
  {
    id: "pova-7-pro",
    index: "07",
    series: "Numbered",
    name: "POVA 7 Pro",
    variant: "Mint Glow",
    /* User-verified campaign tagline — POVA 7 / 7 Pro line */
    tagline: "Better. Faster. Stronger.",
    price: "₹21,999",
    currency: "INR",
    status: "READY",
    flag: "R",
    halo: "#9CE5D4",                /* mint glow cyan */
    spec: ["6.78\" AMOLED 144HZ", "6000 MAH", "8 + 256 GB", "64MP"],
    href: "/pages/pova-7-pro-experience",
    image: "assets/img/pova-7-pro-mint.png"
  },
  {
    id: "pova-curve",
    index: "01",
    series: "Curve",
    name: "POVA Curve",
    variant: "Cyber Orange",
    /* Verified Curve (Gen 1) campaign tagline per 02_Verbal_Identity.md §6 */
    tagline: "Discover New Horizon",
    price: "₹17,999",
    currency: "INR",
    status: "READY",
    flag: "R",
    halo: "#FF5D01",                /* cyber orange (POVA accent) */
    spec: ["6.78\" CURVED AMOLED 1.5K", "5500 MAH", "8 + 128 GB", "5G"],
    href: "/pages/pova-curve-experience",
    image: "assets/img/pova-curve-orange.png"
  },
  /* ─────────── Legacy line ─────────── */
  {
    id: "pova-7",
    index: "07",
    series: "Numbered",
    name: "POVA 7",
    variant: "Oasis Green",
    tagline: "Better. Faster. Stronger.",
    status: "LEGACY",
    flag: "L",
    halo: "#86C8A6",                /* oasis green — softer than mint glow */
    spec: ["6.78\" AMOLED 144HZ", "6000 MAH", "8 + 256 GB", "5G"],
    href: "/pages/pova-7-experience",
    image: "assets/img/legacy/pova-7.jpg"
  },
  {
    id: "pova-6-pro",
    index: "06",
    series: "Numbered",
    name: "POVA 6 Pro",
    variant: "Meteor Grey",
    tagline: "Better. Faster. Stronger.",
    status: "LEGACY",
    flag: "L",
    halo: "#5C6068",                /* meteor grey — cool steel */
    spec: ["6.78\" AMOLED 120HZ", "5000 MAH", "12 + 256 GB", "5G"],
    href: "/pages/pova-6-pro-experience",
    image: "assets/img/legacy/pova-6-pro.jpg"
  },
  {
    id: "pova-5-pro",
    index: "05",
    series: "Numbered",
    name: "POVA 5 Pro",
    variant: "Dark Illusion",
    tagline: "Discover the Light",
    status: "LEGACY",
    flag: "L",
    halo: "#3E4148",                /* dark illusion — graphite */
    spec: ["6.78\" AMOLED 120HZ", "5000 MAH", "8 + 256 GB", "5G"],
    href: "/pages/pova-5-pro-experience",
    image: "assets/img/legacy/pova-5-pro.jpg"
  }
];
